/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class TemplatesListComponent extends Component {
  @service twoWayChat;

  get approvedWhatsappTemplates() {
    return this.twoWayChat.whatsappTemplates.filter(
      (template) => template.status === 'APPROVED'
    );
  }

  @action
  selectTemplate(template) {
    this.twoWayChat.selectedTemplate = template;
    this.twoWayChat.setScreenTask.perform('template-preview');
  }
}
